import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { ApiUrl } from "../../../ApiUrl";

const StaffChangePassword = () => {
  const navigate = useNavigate();
  const username = sessionStorage.getItem("username") || "";
  const loginId = sessionStorage.getItem("loginId") || sessionStorage.getItem("userId");

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!loginId) {
      alert("User session not found. Please login again.");
      return;
    }

    if (!oldPassword || !newPassword || !confirmPassword) {
      alert("Please fill in all fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      alert("New password and confirm password do not match.");
      return;
    }

    if (oldPassword === newPassword) {
      alert("Old password and new password may not be the same.");
      return;
    }

    try {
      setSaving(true);
      const response = await fetch(`${ApiUrl.apiurl}RegisterEmployee/changepassword/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: parseInt(loginId, 10),
          old_password: oldPassword,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }),
      });

      const contentType = response.headers.get("content-type") || "";
      const payload = contentType.includes("application/json")
        ? await response.json()
        : null;

      if (!response.ok) {
        throw new Error(payload?.message || payload?.error || "Unable to change password.");
      }

      alert(payload?.message || "Password changed successfully!");
      handleClear();
    } catch (error) {
      console.error("Error changing staff password:", error);
      alert(error.message || "Unable to change password.");
    } finally {
      setSaving(false);
    }
  };

  const handleClear = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  const handleClose = () => {
    navigate("/staff/dashboard");
  };

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card p-0 ">
            <div className="card-body ">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#000000",
                }}
              >
                CHANGE PASSWORD
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: "150px" }}
                    onClick={handleSave}
                    disabled={saving}
                  >
                    {saving ? "Saving..." : "Save"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                    disabled={saving}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    style={{ width: "150px" }}
                    onClick={handleClose}
                    disabled={saving}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="row mt-3">
                    <div className="col-12 col-lg-8">
                      <div className="mb-4 row align-items-center">
                        <label className="col-sm-4 col-form-label fw-bold">
                          Username<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control detail"
                            value={username}
                            readOnly
                            disabled
                            style={{ backgroundColor: "#eef2f7" }}
                          />
                        </div>
                      </div>

                      <div className="mb-4 row align-items-center">
                        <label className="col-sm-4 col-form-label fw-bold">
                          Old Password<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-8">
                          <div className="input-group">
                            <input
                              type={showOldPassword ? "text" : "password"}
                              className="form-control detail"
                              value={oldPassword}
                              onChange={(e) => setOldPassword(e.target.value)}
                              placeholder="Enter current password"
                            />
                            <span
                              className="input-group-text"
                              onClick={() =>
                                setShowOldPassword((prev) => !prev)
                              }
                              style={{
                                cursor: "pointer",
                                backgroundColor: "#ffffff",
                              }}
                            >
                              {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="mb-4 row align-items-center">
                        <label className="col-sm-4 col-form-label fw-bold">
                          New Password<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-8">
                          <div className="input-group">
                            <input
                              type={showNewPassword ? "text" : "password"}
                              className="form-control detail"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              placeholder="Enter new password"
                            />
                            <span
                              className="input-group-text"
                              onClick={() =>
                                setShowNewPassword((prev) => !prev)
                              }
                              style={{
                                cursor: "pointer",
                                backgroundColor: "#ffffff",
                              }}
                            >
                              {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="mb-4 row align-items-center">
                        <label className="col-sm-4 col-form-label fw-bold">
                          Confirm Password<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-8">
                          <div className="input-group">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              className="form-control detail"
                              value={confirmPassword}
                              onChange={(e) =>
                                setConfirmPassword(e.target.value)
                              }
                              placeholder="Confirm new password"
                            />
                            <span
                              className="input-group-text"
                              onClick={() =>
                                setShowConfirmPassword((prev) => !prev)
                              }
                              style={{
                                cursor: "pointer",
                                backgroundColor: "#ffffff",
                              }}
                            >
                              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffChangePassword;
